import React from 'react';
import { RatingStars } from 'lib/components/ui/rating-stars';
import { formatDecimal } from 'lib/helpers/strings';

type RatingCriterionRowProps = {
  label: string;
  value: number;
};

export function RatingCriterionRow({ label, value }: RatingCriterionRowProps) {
  return (
    <div className="flex items-center justify-between gap-4">
      <span className="text-gray-500">{label} :</span>
      <div className="flex items-center gap-1">
        <RatingStars value={value} readonly size="sm" />
        <span className="font-medium">{formatDecimal(value)}</span>
      </div>
    </div>
  );
}
